import { useHistory } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';
import { IconSettings } from '@rossum/ui/icons/tabler';
import { IconButton, SvgIcon } from '@rossum/ui/material';
import { ViewOptions } from '../../document-list-base/types';

type Props = {
  queueId: number;
  view: ViewOptions;
};

const settingsAppendixPerView = {
  documents: '/basic',
  emails: '/emails',
};

export const SettingsButton = ({ queueId, view }: Props) => {
  const {
    location: { pathname, search },
  } = useHistory();

  const route = `/queues/${queueId}/settings${settingsAppendixPerView[view]}`;

  return (
    <IconButton
      data-cy="queue-settings-btn"
      sx={{
        color: 'secondary.main',
        '&:hover': {
          color: theme => theme.palette.secondary.main,
        },
        '&:visited': {
          color: theme => theme.palette.secondary.main,
        },
      }}
      to={{
        pathname: route,
        state: { backLink: `${pathname}${search}` },
      }}
      component={RouterLink}
    >
      <SvgIcon fontSize="large">
        <IconSettings />
      </SvgIcon>
    </IconButton>
  );
};
